"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setDebugFlag = setDebugFlag;
exports.setLogObserver = setLogObserver;
exports.Logger = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var isDebug = false;

if (typeof window !== 'undefined' && window.location.href.match('login_debug=1')) {
  isDebug = isDebug || !!window.location.href.match('login_debug=1');
}

function setDebugFlag(flag) {
  isDebug = flag;
}

var logObserver;

function setLogObserver(observer) {
  logObserver = observer;
}

var Logger = function Logger(moduleName) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, Logger);
  this.module = void 0;

  this.log = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this.invoke('log', args);
  };

  this.info = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this.invoke('info', args);
  };

  this.error = function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this.invoke('error', args);
  };

  this.invoke = function (level, msgArgs) {
    if (isDebug) {
      var _console, _context;

      (_console = console)[level].apply(_console, (0, _concat["default"])(_context = ["Login[".concat(_this.module, "]")]).call(_context, (0, _toConsumableArray2["default"])(msgArgs)));
    }

    if (typeof logObserver === 'function') {
      logObserver(_this.module, level, msgArgs);
    }
  };

  this.module = moduleName;
};

exports.Logger = Logger;